<template>
  <div class="order-info">
    <h1>订单信息</h1>
    <el-row :gutter="20">
      <el-col :span="10">
        <label>续费单号</label>
        <span>{{ orderDetail.orderNo }}</span>
      </el-col>
      <el-col :span="10">
        <label>续费时间</label>
        <span>{{ orderDetail.renewalTime }}</span>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="10">
        <label>操作人</label>
        <span>{{ optUserNameShowContent(orderDetail.optUserName, orderDetail.accountNo) }}</span>
      </el-col>
      <el-col :span="10">
        <label>公司</label>
        <span>{{ orderDetail.companyName }}</span>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { optUserNameShowContent } from '@/util';
export default {
  name: 'orderInfo',
  props: {
    orderDetail: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    optUserNameShowContent
  }
};
</script>

<style lang="scss" scoped>
.order-info {
  margin-bottom: 24px;
}
h1 {
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  padding: 12px 0 10px 0;
}
.el-row {
  padding: 8px 0;
  .el-col {
    display: flex;
    color: #595959;
    line-height: 22px;
    font-size: 14px;
    label {
      display: block;
      margin-right: 12px;
      min-width: 70px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
  }
}
</style>
